module.exports = __webpack_public_path__ + "img/no_img.9b31646c.svg";